// Current release scope: recommendations and manual meeting-point selection only.
// Keep venue management and post-walk venue ratings available for a future release.
export const VENUE_MANAGEMENT_ENABLED = false;
export const VENUE_RATINGS_ENABLED = false;
